import React from "react";
import "./WelcomeSection.css";

const AboutWelcome = () => {
  return (
    <section className="welcome-section">
      <div className="welcome-container">
        <h1 className="welcome-title">
          About Us - <span>NewZeal</span> Academy
        </h1>

        <p className="welcome-text">At <b>NewZeal Language Academy</b>, we started with one simple goal — to help people speak English with confidence. We saw that many students and professionals know English but still hesitate or struggle to use it in daily life.  <br/><br/>
        This lack of confidence often stops them from getting better opportunities in jobs, studies, social interactions and personal growth. <b>NewZeal</b> was created to change this. <br/><br/>
Our aim is not just to teach English, but to make learning simple, practical, and useful for real life. We believe that when people learn to speak freely and clearly, they can improve their lives and also contribute positively to society.

        </p>

        <p className="welcome-text">
         We know everyone starts at their own level. This is why we shape our courses to suit your needs. You might be a total beginner working to improve your speaking, or gearing up to excel in studies. With skilled English speaking tutors, hands-on lessons, and activities from real life, we keep learning interesting and focused on progress.
        </p>
      </div>
    </section>
  );
};

export default AboutWelcome;
